import React, { useState, useEffect } from "react";

const PdosViewer = ({ materialId }) => {
  const [bandDosUrl, setBandDosUrl] = useState(null);

  // 左侧状态
  const [bandDosLoaded, setBandDosLoaded] = useState(false);

  // 右侧核心状态
  const [rightUrl, setRightUrl] = useState(null);
  const [rightLoaded, setRightLoaded] = useState(false);
  const [interactiveUrl, setInteractiveUrl] = useState(null);
  const [isInteractive, setIsInteractive] = useState(false);

  const backendUrl = process.env.REACT_APP_BASE_URL || "";

  useEffect(() => {
    // 切换材料时，彻底清空上一轮的状态
    setBandDosLoaded(false);
    setRightLoaded(false);
    setIsInteractive(false);

    // 🌟 光速加载：不做任何探测，瞬间分配地址！
    setBandDosUrl(`${backendUrl}/api/get_band_dos_pdf/${materialId}`);
    setRightUrl(`${backendUrl}/api/get_thermal_properties_pdf/${materialId}`);
    setInteractiveUrl(`${backendUrl}/api/get_pdos_html/${materialId}`);

  }, [materialId, backendUrl]);

  // 处理用户点击“升级为交互图”的按钮
  const handleLoadInteractive = () => {
    setRightLoaded(false); // 重新转起加载圈
    setRightUrl(interactiveUrl); // 把 iframe 的地址换成沉重的 HTML
    setIsInteractive(true); // 隐藏按钮
  };

  // 🎨 通用加载圈组件
  const LoadingSpinner = ({ text }) => (
    <div style={{
      position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)",
      display: "flex", flexDirection: "column", alignItems: "center", color: "#64748b"
    }}>
      <div style={{
        width: "35px", height: "35px", border: "4px solid #e2e8f0",
        borderTop: "4px solid #3b82f6", borderRadius: "50%", animation: "spin 1s linear infinite"
      }} />
      <p style={{ marginTop: "12px", fontWeight: "500", fontSize: "14px" }}>{text}</p>
      <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
    </div>
  );

  return (
    <div style={{ display: "flex", gap: "24px", width: "100%", marginTop: "20px" }}>

      {/* ================= 左侧：Band DOS 区域 ================= */}
      <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
        <h4 style={{ fontWeight: "bold", marginBottom: "12px", textAlign: "center", color: "#374151" }}>
          Phonon Spectrum & PDOS
        </h4>
        <div style={{ position: "relative", width: "100%", height: "600px", backgroundColor: "#f8fafc", borderRadius: "8px", border: "1px solid #e5e7eb", overflow: "hidden" }}>

          {!bandDosLoaded && <LoadingSpinner text="Loading PDF Preview..." />}

          {bandDosUrl && (
            <iframe
              src={bandDosUrl}
              width="100%"
              height="100%"
              style={{ border: "none", display: bandDosLoaded ? "block" : "none" }}
              title="Band DOS PDF"
              onLoad={() => setBandDosLoaded(true)}
            />
          )}
        </div>
      </div>

      {/* ================= 右侧：Thermal / BDOS 区域 ================= */}
      <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
        <h4 style={{ fontWeight: "bold", marginBottom: "12px", textAlign: "center", color: "#374151" }}>
          Thermal Properties / BDOS
        </h4>
        <div style={{ position: "relative", width: "100%", height: "600px", backgroundColor: "#f8fafc", borderRadius: "8px", border: "1px solid #e5e7eb", overflow: "hidden" }}>

          {/* 动态变化的加载文字 */}
          {!rightLoaded && rightUrl && <LoadingSpinner text={isInteractive ? "Rendering High-Res HTML..." : "Loading PDF Preview..."} />}

          {/* 🌟 核心：悬浮的升级按钮，现在瞬间出现！ */}
          {!isInteractive && interactiveUrl && (
            <div style={{ position: "absolute", bottom: "20px", right: "20px", zIndex: 10 }}>
              <button
                onClick={handleLoadInteractive}
                style={{
                  padding: "10px 20px", backgroundColor: "#3b82f6", color: "white",
                  borderRadius: "8px", border: "none", cursor: "pointer",
                  boxShadow: "0 4px 10px rgba(0,0,0,0.2)", fontWeight: "bold",
                  transition: "background-color 0.3s"
                }}
                onMouseOver={(e) => e.target.style.backgroundColor = '#2563eb'}
                onMouseOut={(e) => e.target.style.backgroundColor = '#3b82f6'}
              >
                ✨ Load Interactive HTML
              </button>
            </div>
          )}

          {rightUrl && (
            <iframe
              src={rightUrl}
              width="100%"
              height="100%"
              style={{ border: "none", display: rightLoaded ? "block" : "none" }}
              title="Thermal Properties or BDOS Plot"
              onLoad={() => setRightLoaded(true)}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default PdosViewer;